import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../App';
import axios from 'axios';
import { LoadingFull, LoadingOverlay } from '../../loading';

const Phone = ({error, setError, phone, setPhone}) => {
  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'auto'})
  }, [])
  return (
    <div className="space-y-2">
      <div className="">
        <h2 className="text-base xl:text-lg font-medium">Indtast dit mobilnummer</h2>
        <div className="text-sm xl:text-base">
          <h2 className="">Vi sender en SMS til dig, når din bog bliver solgt.</h2>
        </div>
      </div>
      <div className="bookDetails w-full flex-wrap space-y-8">
        <div className="flex flex-col gap-4">
          <div className="title w-full flex flex-col gap-2">
            {(error !== '') ? <h2 className="text-sm font-medium text-red-500">{error}</h2> : ""}
            <div className="w-full relative flex items-center ring-1 ring-neutral-300 focus-within:ring-2 focus-within:ring-emerald-700">
              <label className="block focus:outline-none pl-4 text-sm">+45</label>
              <input type="text" inputMode="numeric" id="phone" maxLength="11" autoComplete='none' onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/gi, "").replace(/(\d{2})(?=\d)/g, "$1 ")} defaultValue={phone.replace(/\d{2}(?=.)/g, '$& ')} autoFocus={phone.length !== 8} onChange={(e) => setPhone(e.target.value.replace(/ /g, '')) & setError('')} className="block focus:outline-none text-sm text-gray-900 p-4 pl-1 w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Phone